import {FETCH_FILTERSPACENAME,
    FETCH_FILTERSPACENAME_SUCCESS,
    FETCH_FILTERSPACENAME_FAILS,
    FETCH_SPACEDETAILS,
    FETCH_SPACEDETAILS_SUCCESS,
    FETCH_SPACEDETAILS_FAILS,
} from './AssignSpaceActionType'

export const assignSpaceReducer = (
state = {    
},
action
) => {
switch (action.type) {
case FETCH_FILTERSPACENAME:
    return {
      ...state,
      filterSpaceName: {
        ...state.filterSpaceName,
        fetching: true,
        error: { status: false, message: '' }
      }
    };

case FETCH_FILTERSPACENAME_SUCCESS:
    return {
      ...state,
      filterSpaceName: {
        ...state.filterSpaceName,
        fetching: false,
        error: { status: false, message: '' },
        data: action.payload
      }
    };

case FETCH_FILTERSPACENAME_FAILS:
    return {
      ...state,
      filterSpaceName: {
        ...state.filterSpaceName,
        fetching: false,
        error: { status: true, message: action.payload }
      }
    };

case FETCH_SPACEDETAILS:
      return {
        ...state,
        spaceDetails: {
          ...state.spaceDetails,
          fetching: true,
          error: { status: false, message: '' }
        }
    }; 

case FETCH_SPACEDETAILS_SUCCESS:
      return {
        ...state,
        spaceDetails: {
          ...state.spaceDetails,
          fetching: false,
          error: { status: false, message: '' },
          data: action.payload
      }
    };

case FETCH_SPACEDETAILS_FAILS:
      return {
        ...state,
        spaceDetails: {
          ...state.spaceDetails,
          fetching: false,
          error: { status: true, message: action.payload }
        }
      };

default:
    return state;
}
};
